import { useCurrentUser } from '../user';

import { usePeoStaff } from './usePeoStaff';

export const useCurrentPeoStaff = () => {
  const { user } = useCurrentUser();
  const { peoStaff, loading } = usePeoStaff(user?.peoStaff?.id);

  const peoStaffId = peoStaff?.id;
  const peoId = peoStaff?.peo.id;

  return {
    peoStaffId,
    peoStaff,
    peoId,
    loading,
  };
};
